import request from '.././api/config'
import Global from './global'
import filter from './filter'
import uuid from './unit'
import store from '../store/index'
const groupid = Global.groupid
async function getfloorlistmd(round) {
  return request
    .get(`StudentData/GetAllFloorInstance?groupId=${groupid}&round=${round}`)
    .then((res) => {
      if (res.success) {
        return res.dynamicObj
      }
    })
    .catch(() => {
      return []
    })
}
async function createTaskBar(round,status,type)
{
  return request
  .get('TaskBars/CreateTaskBar?round='+round+'&status='+status+'&type='+type)
  .then((res)=>{
    store.commit("GetTaskBar", !store.state.user.taskBar); 
    return res.dynamicObj
  })
  .catch(() => {
    return []
  })
}
async function pushIncomet(list,type) {
  let IncomeList = []
  request
    .get(
      'SModel/GetSModelIncome?round=' +
        list[0].round +
        '&payType=' +
        list[0].buissType
    )
    .then((res) => {
      if (res.success) {
        console.log(list[0].buissId)
        IncomeList = res.dynamicObj.filter((c) => c.buissId == list[0].buissId)
       
        if (IncomeList.length > 0 && type==1
        ) {
          list = IncomeList
          list[0].state = Global.SModel.Delete
        } else if (
          IncomeList.length > 0 && type==0
        ) {
          let pay = list[0].buissValue
          list = IncomeList
          list[0].buissValue = pay
          list[0].state = Global.SModel.Update
          list[0].createTime = filter.formatDate(new Date())
          console.log(list)
        } else {
          list[0].type = 'S_Income'
          list[0].sTTime = filter.formatDate(new Date())
          list[0].createTime = filter.formatDate(new Date())
          list[0].uuid = uuid.guid()
          list[0].state = Global.SModel.Create
          list[0].financeType = Global.FinanceType.支出
        }
        return request
          .post(`SModel/PushStrategy`, Global.getsmodel(list))
          .then((res) => {
            if (res.success) {
              return res.dynamicObj
            }
          })
          .catch(() => {
            return []
          })
      }
    })
}
export default {
  getfloorlistmd,
  pushIncomet,
  createTaskBar
}
